import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginModel } from '../../../model/login-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, SharedModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup;
  clientId: string | null = null;

  constructor(private authService: AuthService, private fb: FormBuilder, private spinner: NgxSpinnerService) {
    this.clientId = this.authService.getClienteIdLocal();
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }



  login() {
    this.spinner.show();
    var model = this.loginForm.value as LoginModel;
    model.clientId = this.authService.verificaClientId(this.clientId ?? '');

    this.authService.login(model).subscribe({
      next: (response) => {
        const redirectUrl = response.redirectUrl;
        if (redirectUrl) {
          this.spinner.hide();
          window.location.href = redirectUrl;
        } else {
          this.spinner.hide();
          console.error('URL de redirecionamento não encontrada');
        }
      },
      error: (error) => {
        alert("Erro ao realizar login");
        console.error(error);
        this.spinner.hide();
      },
    });
  }



}
